import React from "react";
import { useTranslation } from "react-i18next";

const PageNotFound = () => <h2>{useTranslation().t("Page not found")}</h2>;

export default PageNotFound;
